import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { handle_error, handle_success } from "@/utils/wretch";
import { Outlet, RouteObject } from "react-router-dom";

const InstallmentScheduleRoute: RouteObject = {
    path: "echeanciers",
    element: (
        <Protected>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            path: ":installmentScheduleId",
            action: async ({ params, request }) => {
                const installmentScheduleId = params.installmentScheduleId;
                const data = await request.json();
                const url = new URL(request.url);
                const action = url.searchParams.get("action");
                if (action) {
                    try {
                        const content = await DataService.client.url(`/registration/sales/installment_schedules/${installmentScheduleId}/${action}/`).post(data).json();
                        return handle_success(content);
                    } catch (error) {
                        return handle_error(error);
                    }
                }
                return {};
            }
        }
    ]
};
export default InstallmentScheduleRoute;
